import { TLabelColor } from '@smartshell/ui-kit';

import { ESubscription } from 'features';

export const getSubscriptionColor = (
  subscription: ESubscription
): TLabelColor => {
  switch (subscription) {
    case ESubscription.TRIAL:
      return 'violetGradient';
    case ESubscription.BUSINESS:
      return 'violet';
    case ESubscription.STARTER:
      return 'green';
    default:
      return 'blue';
  }
};
